import React from 'react'

function Newsletter() {
    return (
        <section className='border-t border-black'>
            <div className='app-main-container flex flex-col sm:flex-row gap-6 sm:py-12'>
                <div className='flex-1'>
                    <p className='text-base sm:text-2xl font-bold app-animation-translate-start'>
                        Be the first to know <br />our latest news
                    </p>
                </div>
                <div className='flex-1 space-y-2 app-animation-scale-start'>
                    <label className='text-xs sm:text-base font-semibold uppercase'>
                        Subscribe now
                    </label>
                    <div className='flex gap-2'>
                        <input className='flex-1 border border-app-light-grey px-3 sm:px-4 py-2 rounded-md text-xs sm:text-sm' placeholder='Enter your email address...' />
                        <button className='text-xs sm:text-sm bg-black px-3 sm:px-4 py-2 text-white rounded-md'>Submit</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Newsletter